//Auth Constants
export const AUTH_SUCCESS = "auth/SUCCESS";
export const AUTH_FAILURE = "auth/FAILURE";
export const AUTHORIZATION_FAILURE = "authorization/FAILURE";
export const AUTH_ERROR = "auth/ERROR";
export const AUTH_SIGNOUT = "auth/SIGNOUT";

//Application Constants
export const CHANGE_APP_PARAMETERS = "change/APP_PARAMETERS";
export const CHANGE_FROM_DATE = "change/FROM_DATE";
export const CHANGE_DATE = "change/DATE";
export const CHANGE_XTD = "change/XTD";
export const CHANGE_BUSINESS_UNIT_AGGREGATION = "change/BUSINESS_UNIT_AGGREGATION";
export const CHANGE_CLIENT_CONCEPT = "change/CLIENT_CONCEPT";
export const GET_CLIENT_CONCEPT_PAGES = "get/CLIENT_CONCEPT_PAGES";
export const USER_SETTINGS_SAVE = "save/USER_SETTINGS";
export const USER_SETTINGS_CONFIRM = "confirm/USER_SETTINGS";
export const USER_SETTINGS_ERROR = "error/USER_SETTINGS";
export const GET_OPEN_TASK_COUNT = "get/OPEN_TASK_COUNT";
export const SWITCH_CURRENT_SELECTED_BUSINESS_UNIT = "switch/CURRENT_BUSINESS_UNIT";
export const RECEIVE_DOMAIN_SETTINGS = "receive/DOMAIN_SETTINGS";
export const ERROR_DOMAIN_SETTINGS = "error/DOMAIN_SETTINGS";
export const HANDLE_FREEMIUM_MARKETING_MODAL = "handle/FREEMIUM_MARKETING_MODAL";
export const HANDLE_METRIC_CONFIGURATION_SAVE_BUTTON =
    "handle/METRIC_CONFIGURATION_SAVE_BUTTON";
export const CHANGE_DELIVERY_PROVIDER_PAYOUT_DATES =
    "change/DELIVERY_PROVIDER_PAYOUT_DATES";
export const HANDLE_SCREEN_RESIZE = "handle/SCREEN_RESIZE";
export const CHANGE_CURRENCY_CODE = "change/CURRENCY_CODE";

// action for assigning the business unit selectin for the Tasks or Visual
export const BUSINESSUNIT_UNSELECT_ALL = "store/UNSELECT_ALL";
export const BUSINESSUNIT_SELECTION_UPDATE = "businessUnit/UPDATE";

export const SURVEY_TAB_ACTIVATE = "surveyTab/ACTIVATE";

// actions for the Metric Details Table checkbox selection
export const METRICDETAIL_TABLE_BUSINESSUNITS_SELECT =
    "metricDetailTable/businessUnitSelect";
export const METRICDETAIL_TABLE_BUSINESSUNIT_UNSELECT_ALL =
    "metricDetailTable/businessUnitUnSelectAll";
export const METRICDETAIL_TABLE_BUSINESSUNITS_UNSELECT =
    "metricDetailTable/businessUnitUnselect";
export const CHANGE_DELIVERY_PROVIDER_AGGREGATION =
    "change/DELIVERY_PROVIDER_AGGREGATION";
export const SWITCH_CURRENT_SELECTED_DELIVERY_PROVIDER =
    "switch/CURRENT_DELIVERY_PROVIDER";
